import React, { useEffect, useState } from "react";

export const DynamicLoadComponent: React.FC<{ path: string; componentProps?: any }> = (props: {
	path: string;
	componentProps?: any;
}) => {
	const [Component, setComponent] = useState<any>(null);

	useEffect(() => {
		import(`${props.path}`).then(({ default: Component }) => {
			setComponent(Component);
		});
	}, []);

	if (Component) return <Component {...props.componentProps} />;
	return null;
};
